<template>
    <div class="stats-loader">
        <div :class="CssClass" class="stats-link-loader" @click="OpenStats">
            {{Text}}
        </div>
        
        <div v-show="ShowStats" v-if="LoadReport" class="window-container" :id="$id(Id)" :class="$id(Id)">
            <div class="window-center">
                <div class="window">
                    <div class="window-header">
                        <span class="close cancel" @click="ClodeModal">X</span>
                        <h3>{{Title}}</h3>
                    </div>
                    <div class="window-body">
                        <ReportLoader v-if="LoadReport" :ReportPath="ReportPath" start-on-mount clean-on-destroy @ReportLoaded="ReportLoaded" />                                
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const DEFAULT_REPORT_SETUP = {
    autorun: true,
    nomasterpage: 1,
    nofilters: 1,
    noexportAAA: 1,
    nosave: 1,
    noschedule: 1
}

import ReportLoader from '../Container/ReportLoader'
import md5 from 'md5'

export default {
  name: "StatsLinkLoader",
  components: { ReportLoader },
  data () {
      return {
        ShowStats: false,
        LoadReport: false
      }
  },
  props: {
      Id: String,
      Title: String,
      CssClass: String,
      Text: String,
      ReportActionName: String,
      ReportData: String,
      OnWindow: Boolean
  },
  computed: {
    ReportPath () {
        let path = `${window.location.origin}${window.location.pathname}?action=${this.ReportActionName}`                   
        let pathmd5 = `${window.location.host}${window.location.pathname}?action=${this.ReportActionName}`
        
        let reportDataAsQueryString = ''
        let options = DEFAULT_REPORT_SETUP

        let reportData = JSON.parse(this.ReportData)    

        if (reportData) options = {...options, ...reportData}
        // if (options.token) options.token = JSON.stringify(options.token)

        for (let [key, value] of Object.entries(options)) {
            reportDataAsQueryString += `&${key}=${value}`
        }

        return `${path}${reportDataAsQueryString}&tokenmd5=${md5(pathmd5+reportDataAsQueryString)}`
    }
  },
  methods: {
    ClodeModal (){
        this.ShowStats = false
        this.LoadReport = false
        // eslint-disable-next-line no-undef
        Utility.removeModalBackGroundUnder(window.top.$($(this)));                                
    },
    ReportLoaded (){
        // const self = this
        this.ShowStats = true        

        // eslint-disable-next-line no-undef
        Utility.HideLoading();        
    },
    OpenStats () {
   if (this.OnWindow) {
   window.open(this.ReportPath, 'LinkColumn', 'width=auto, height=auto, left=100, top=100, auto, resizable');
        } else {
            // eslint-disable-next-line no-undef
            Utility.ShowLoading();
            if (!this.LoadReport) {
                this.LoadReport = true
            } else {
                this.ReportLoaded()
            }
        }        
    }
  }
};
</script>
<style>  

    /* Override Table CSS */
    .window-container .table tbody tr:nth-child(odd) td,
    table tbody tr:hover td .window-container .table tbody tr:nth-child(odd) td {
        background-color: #FFF;
    }

    .window-container .table tbody tr:nth-child(even) td,
    table tbody tr:hover td .window-container .table tbody tr:nth-child(even) td {
        background-color: #E8F5FF;
    }

    .window-container .table tbody tr.rowTotal td,
    table tbody tr:hover td .window-container .table tbody tr.rowTotal td  {
        background-color: #0073EA;
        color: white;
        font-weight: bold;
        vertical-align: top;
    }
    
    .window-container table tbody tr:hover td, 
    table tbody tr:hover td .window-container table tbody tr:hover td, 
    .table tbody tr:hover:nth-child(even) td,
    table tbody tr:hover td .window-container .table tbody tr:hover:nth-child(even) td {
        border-bottom-color: #BDC5C9;
        background-color: #E0E0E9;
    }

    .window-container table tbody tr:hover td, 
    table tbody tr:hover td .window-container table tbody tr:hover td, 
    .table tbody tr:hover:nth-child(odd) td,
    table tbody tr:hover td .window-container .table tbody tr:hover:nth-child(odd) td {
        border-bottom-color: #BDC5C9;
        background-color: #E0E0E9;
    }

    /* Override Table CSS */
    
    .stats-loader .window-container {
        background-color:  rgba(51, 51, 51, .6)
    }

    .stats-loader .window-container .window-center .window .window-body {
        height: 800px;        
        overflow: auto;
    }

    .stats-loader .stats-link-loader {
        margin: 0 10px;
        color: #000fbd;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
    }
</style>